export function createEmptyActivityTypeDraft() {
  return {
    id: null,
    name: '',
    isActive: true,
    isDayService: false,
    visibilityMode: 'base',
    supportsA3Za3: true,
    supportsTGroup: false,
    supportsHonorar: false,
    keywordMode: 'optional',
    hoursQuestionMode: 'required',
    responsibleQuestionMode: 'uebungsleiter',
    responsibleQuestionText: '',
    eventContextMode: 'veranstaltung',
    timeQuestionText: '',
    timeEntryMode: 'custom-only',
    autoResponsibleMode: 'none',
    pauseMode: 'hidden-no-deduction',
    pdfProtocolMode: 'hidden',
    serviceDurationLabel: 'Dienstzeit (abzgl. Pause)',
    protocolCode: '',
    scaleWorkHours: false,
    sortOrder: 999,
  };
}

export const ACTIVITY_TYPE_TEMPLATES = Object.freeze([
  {
    id: '24h-uebung',
    label: '24h-Übung',
    description: 'Vorgabe oder freier Zeitraum, keine Pausenfrage, Standard-Sichtbarkeit.',
    values: {
      isDayService: false,
      visibilityMode: 'base',
      supportsA3Za3: false,
      supportsTGroup: false,
      supportsHonorar: false,
      keywordMode: 'optional',
      hoursQuestionMode: 'required',
      responsibleQuestionMode: 'uebungsleiter',
      responsibleQuestionText: '',
      eventContextMode: 'uebung',
      timeQuestionText: '',
      timeEntryMode: 'preset-or-custom',
      autoResponsibleMode: 'none',
      pauseMode: 'hidden-no-deduction',
      pdfProtocolMode: 'hidden',
      serviceDurationLabel: 'Dienstzeit (abzgl. Pause)',
      protocolCode: '',
      scaleWorkHours: false,
    },
  },
  {
    id: '24h-einsatz',
    label: '24h-Einsatz',
    description: 'Freier Zeitraum, Einheitsführer-Frage, keine Pausenfrage.',
    values: {
      isDayService: false,
      visibilityMode: 'base',
      supportsA3Za3: false,
      supportsTGroup: false,
      supportsHonorar: false,
      keywordMode: 'optional',
      hoursQuestionMode: 'required',
      responsibleQuestionMode: 'einheitsfuehrer',
      responsibleQuestionText: '',
      eventContextMode: 'einsatz',
      timeQuestionText: '',
      timeEntryMode: 'custom-only',
      autoResponsibleMode: 'none',
      pauseMode: 'hidden-no-deduction',
      pdfProtocolMode: 'hidden',
      serviceDurationLabel: 'Dienstzeit (abzgl. Pause)',
      protocolCode: '',
      scaleWorkHours: false,
    },
  },
  {
    id: 'tagesdienst-a3-za3',
    label: 'Tagesdienst A3/zA3',
    description: 'A3/zA3-Logik mit Pausenfrage, PDF-Abfrage und skalierten Dienstzeiten.',
    values: {
      isDayService: true,
      visibilityMode: 'instructor',
      supportsA3Za3: true,
      supportsTGroup: false,
      supportsHonorar: false,
      keywordMode: 'optional',
      hoursQuestionMode: 'required',
      responsibleQuestionMode: 'uebungsleiter',
      responsibleQuestionText: '',
      eventContextMode: 'veranstaltung',
      timeQuestionText: '',
      timeEntryMode: 'a3-za3',
      autoResponsibleMode: 'none',
      pauseMode: 'question',
      pdfProtocolMode: 'ask',
      serviceDurationLabel: 'Dienstzeit (abzgl. Pause)',
      protocolCode: '',
      scaleWorkHours: true,
    },
  },
  {
    id: 'tagesdienst-t-honorar',
    label: 'Tagesdienst T/Honorar',
    description: 'T1/T2-, Flex- und Honorar-Ablauf mit skalierten Dienstzeiten.',
    values: {
      isDayService: true,
      visibilityMode: 'instructor',
      supportsA3Za3: false,
      supportsTGroup: true,
      supportsHonorar: true,
      keywordMode: 'optional',
      hoursQuestionMode: 'required',
      responsibleQuestionMode: 'uebungsleiter',
      responsibleQuestionText: '',
      eventContextMode: 'veranstaltung',
      timeQuestionText: '',
      timeEntryMode: 'te1-flex-honorar',
      autoResponsibleMode: 'none',
      pauseMode: 'question',
      pdfProtocolMode: 'ask',
      serviceDurationLabel: 'Dienstzeit (abzgl. Pause)',
      protocolCode: '',
      scaleWorkHours: true,
    },
  },
  {
    id: 'srht-grundlehrgang',
    label: 'SRHT-Sonderworkflow',
    description: 'Lehrgangsleiter-Frage, SRHT-Workflow, Stundenfrage ausgeblendet.',
    values: {
      isDayService: false,
      visibilityMode: 'srht-training',
      supportsA3Za3: false,
      supportsTGroup: false,
      supportsHonorar: false,
      keywordMode: 'optional',
      hoursQuestionMode: 'hidden',
      responsibleQuestionMode: 'lehrgangsleiter',
      responsibleQuestionText: '',
      eventContextMode: 'veranstaltung',
      timeQuestionText: '',
      timeEntryMode: 'srht-basic-course',
      autoResponsibleMode: 'none',
      pauseMode: 'hidden-no-deduction',
      pdfProtocolMode: 'hidden',
      serviceDurationLabel: 'Dienstzeit',
      protocolCode: '',
      scaleWorkHours: false,
    },
  },
]);

export function createDraftFromTemplate(templateId, overrides = {}) {
  const template = ACTIVITY_TYPE_TEMPLATES.find((item) => item.id === templateId);
  return {
    ...createEmptyActivityTypeDraft(),
    ...(template?.values || {}),
    ...overrides,
    id: null,
  };
}

export function getActivityTypeTemplate(templateId) {
  return ACTIVITY_TYPE_TEMPLATES.find((item) => item.id === templateId) || null;
}